<template>
  <Transition name="authorize-fade">
    <div class="authorize-overlay" v-if="visible">
      <div class="authorize-modal">
        <!-- 背景图 -->
        <img
          src="../assets/authorize/modal-bg.png"
          alt=""
          class="authorize-bg"
        />
        <!-- 关闭按钮 -->
        <div class="authorize-close" @click="handleClose">
          <CloseOutlined />
        </div>

        <!-- 内容区 -->
        <div class="authorize-content">
          <!-- 警告图标 -->
          <div class="authorize-warning">
            <img src="../assets/authorize/warning.png" alt="警告" />
          </div>

          <!-- 主消息 -->
          <div class="authorize-title">
            您的平台授权将于（
            <span class="expire-date">
              {{ authorityData.expirationTime }}
            </span>
            ）到期
          </div>

          <!-- 描述文字 -->
          <p class="authorize-desc">
            到期后系统将禁止向检测设备下发任务，设备将无法启动试验。建议提前续费，避免影响检测计划安排。
          </p>

          <!-- 剩余天数 -->
          <div class="authorize-remaining">
            <img
              src="../assets/authorize/remaining-days.png"
              alt=""
              class="remaining-frame"
            />
            <div class="remaining-content">
              <span class="remaining-text">距平台结束授权还有</span>
              <div class="remaining-digits">
                <div
                  class="digit-box"
                  v-for="(digit, index) in remainingDaysArr"
                  :key="index"
                >
                  {{ digit }}
                </div>
              </div>
              <span class="remaining-text">天</span>
            </div>
          </div>

          <!-- 联系电话 -->
          <div class="contact-content">
            <span class="contact-label">联系电话：</span>
            <span class="contact-number">136 1823 0006</span>
            <span class="contact-or">或</span>
            <span class="contact-number">153 1095 6905</span>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, defineExpose, ref } from "vue";
import { CloseOutlined } from "@ant-design/icons-vue";

const authorityData = ref({});
const visible = ref(false);

const remainingDaysArr = computed(() => {
  return String(authorityData.value.daysRemaining).split("");
});

const handleClose = () => {
  visible.value = false;
  authorityData.value = {};
};
const onOpen = (data) => {
  visible.value = true;
  authorityData.value = data;
};
defineExpose({ onOpen });
</script>

<style scoped>
.authorize-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.authorize-modal {
  position: relative;
  width: 4.6rem;
  /* height: 2.8rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.authorize-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 0;
  border-radius: 0.04rem;
}

.authorize-close {
  position: absolute;
  top: 0.06rem;
  right: 0.06rem;
  width: 0.16rem;
  height: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 0.03rem;
  cursor: pointer;
  z-index: 2;
  transition: background 0.3s;
}

.authorize-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.authorize-close :deep(.anticon) {
  color: #fff;
  font-size: 0.08rem;
}

.authorize-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.26rem 0.2rem 0.35rem 0.2rem;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.authorize-warning {
  margin-top: 0.05rem;
}

.authorize-warning img {
  width: 0.7rem;
  /* height: 0.6rem; */
  object-fit: contain;
}

.authorize-title {
  margin: 0.12rem 0 0;
  font-size: 0.14rem;
  font-weight: bold;
  color: #63e5ef;
  text-align: center;
  line-height: 1.5;
}

.authorize-title .expire-date {
  color: #63e5ef;
}

.authorize-desc {
  margin: 0.08rem 0 0;
  font-size: 0.11rem;
  color: #cbcbcb;
  text-align: center;
  line-height: 1.8;
  max-width: 75%;
}

.authorize-remaining {
  position: relative;
  margin-top: 0.15rem;
  width: 2.8rem;
  height: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remaining-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.remaining-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.05rem;
}

.remaining-text {
  font-size: 0.1rem;
  color: #fff;
  white-space: nowrap;
  font-size: 0.14rem;
}

.remaining-digits {
  display: flex;
  gap: 0.02rem;
}

.digit-box {
  padding: 0 0.03rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    180deg,
    transparent 0%,
    #617aa2 50%,
    transparent 100%
  );
  border-radius: 0.02rem;
  color: #fff;
  font-size: 0.2rem;
  font-family: "PangMenZhengDao", sans-serif;
}

.contact-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.05rem;
  font-size: 0.1rem;
  margin-top: 0.15rem;
  padding: 0.05rem 0.1rem;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #617aa262 50%,
    transparent 100%
  );
}
.contact-label {
  color: #fff;
  white-space: nowrap;
}

.contact-number {
  font-family: "PangMenZhengDao", sans-serif;
  color: #63e5ef;
  letter-spacing: 0.01rem;
  font-size: 0.14rem;
}

.contact-or {
  color: #fff;
}

/* Transition 动画 */
.authorize-fade-enter-active,
.authorize-fade-leave-active {
  transition: opacity 0.3s ease;
}

.authorize-fade-enter-from,
.authorize-fade-leave-to {
  opacity: 0;
}
</style>
